.container {
  padding: 10px 30px;
  min-height: 100vh;
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  box-sizing: border-box;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 15px;
    min-width: unset;
    width: 100%;
  }
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media print {
  .headerContainer {
    display: none !important;
  }
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mobileMenu {
  display: none;
}

@media (max-width: 600px) {
  .headerActions {
    display: none;
  }

  .mobileMenu {
    display: flex;
  }
}
